import { BackButton } from "../../components/features/BackButton";
import { paths } from "../../config/paths";
import { useNavigate } from "react-router-dom";

export const LooksGalleryHome = () => {
  return (
    <div className="flex flex-col h-full">
      <HeroSection
        title="Beauty services"
        subtitle="Your glamorous journey"
        backgroundImage="/looks-gallery/beauty-services/home.jpg"
        path={paths.looksGallery.beautyServices.path}
      />
      <HeroSection
        title="La galerie des looks"
        subtitle="Reveal your beauty with sophistication"
        backgroundImage="/looks-gallery/looks-gallery/home.png"
        backgroundPosition="center"
        path={paths.looksGallery.looksGallery.path}
        backButton={true}
      />
    </div>
  );
};

interface HeroSectionProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  backgroundPosition?: string;
  backButton?: boolean;
  path: string;
}

export const HeroSection = ({
  title,
  subtitle,
  backgroundImage,
  backgroundPosition = "right",
  backButton = false,
  path,
}: HeroSectionProps) => {
  const navigate = useNavigate();
  return (
    <div
      className="h-1/2 flex flex-col justify-end gap-6 p-6 cursor-pointer"
      style={{
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: "cover",
        backgroundPosition,
      }}
      onClick={() => navigate(path)}
    >
      {backButton && (
        <div 
          className="text-white"
          onClick={(e) => e.stopPropagation()}
        >
          <BackButton onClick={() => navigate(paths.app.path)} />
        </div>
      )}
      <div className="flex w-full p-4 flex-col rounded-[2px] bg-[rgba(5,5,5,0.2)] backdrop-blur-xl">
        <h1 className="text-white text-center font-bebas-kai text-[40px] font-normal">
          {title}
        </h1>
        <p className="text-white text-center font-garamond-italic text-[20px] italic font-normal">
          {subtitle}
        </p>
      </div>
    </div>
  );
};
